import React from 'react';
import styled from 'styled-components';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm } from 'rc-form';
import Modal from '../../../SolvPatternLibrary/Modal';
import TabView from '../../Views/TabView';
import CloseX from '../../../SolvPatternLibrary/Icons/CloseX';
import SelectTimeButton from '../../components/SelectTimeButton';
import { EN, SupportedLocale } from '../../../../core/util/localizedStr';

const Container = styled.div.withConfig({ componentId: 'sc-16n28fc-0' })`
  background-color: white;
  display: block;
`;

const SlotsContainer = styled.div.withConfig({ componentId: 'sc-16n28fc-1' })`
  margin: 50px 0 25px 0;
`;

export const WIDGET_BOOKING_TIME_SELECTOR_MODAL = 'widget_booking_time_selector_modal';

type Props = {
  buttonType?: 'button' | 'submit' | 'reset';
  fullScreen: boolean;
  onClose: (...args: any[]) => any;
  isMoreDate: boolean;
  selectedDate: any;
  location: any;
  setAndHandleDate: (...args: any[]) => any;
  futureSlotData: any;
  handleSelectSlot: (...args: any[]) => any;
  nextDate: any;
  selectedSlots: any[];
  setIsMoreDate: (...args: any[]) => any;
  setSelectedSlot: (...args: any[]) => any;
  onModalSubmit?: () => void;
  open: boolean;
  shouldShowWalkInCopy?: boolean;
  blurField?: (...args: any[]) => any;
  locale?: SupportedLocale;
  // Below props are for old booking flow
  shouldSelectFirstSlotAsInitialValue: boolean;
};

const TimeSelectorModal = (props: Props) => {
  const {
    buttonType,
    fullScreen,
    onClose,
    isMoreDate,
    selectedDate,
    location,
    setAndHandleDate,
    futureSlotData,
    handleSelectSlot,
    nextDate,
    selectedSlots,
    setIsMoreDate,
    onModalSubmit,
    open,
    shouldShowWalkInCopy,
    locale = EN,
    // below props are for old booking flow
    shouldSelectFirstSlotAsInitialValue,
  } = props;

  const handleCloseModal = () => onClose(WIDGET_BOOKING_TIME_SELECTOR_MODAL);

  const handleSelectSlotAndClose = (e: any) => {
    e.preventDefault();
    handleSelectSlot(selectedSlots);
    handleCloseModal();
  };

  return (
    <Modal
      fullScreen={fullScreen}
      fullWidth
      onClose={handleCloseModal}
      open={open}
      scroll="body"
      width={600}
    >
      <form onSubmit={handleSelectSlotAndClose}>
        <Container>
          <CloseX onClick={handleCloseModal} />

          <SlotsContainer>
            <TabView
              futureSlotData={futureSlotData}
              handleSelectSlot={handleSelectSlot}
              isMoreDate={isMoreDate}
              locale={locale}
              location={location}
              nextDate={nextDate}
              selectedDate={selectedDate}
              selectedSlots={selectedSlots}
              setAndHandleDate={setAndHandleDate}
              setIsMoreDate={setIsMoreDate}
              shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
              shouldShowWalkInCopy={shouldShowWalkInCopy}
            />
          </SlotsContainer>

          <SelectTimeButton
            buttonType={buttonType}
            locale={locale}
            location={location}
            onModalSubmit={onModalSubmit}
            selectedSlot={selectedSlots}
            shouldShowApptDateInButton
          />
        </Container>
      </form>
    </Modal>
  );
};

export default createForm()(TimeSelectorModal);
